<template>
  <div id="app">
   <router-view />
   <leo-nl-locale-pack-banner />
   <leo-admin-float-dock />
   <leo-training-operator-assistant-host />
   <soc-smart-guide-float />
  </div>
</template>

<script>
import { getLayoutTheme } from '@/utils/layoutTheme'
import { initLeoFloatDockFromStorage } from '@/utils/leoAdminFloatDock'
import LeoAdminFloatDock from '@/components/LeoAdmin/LeoAdminFloatDock.vue'
import LeoNlLocalePackBanner from '@/components/LeoNlLocalePackBanner.vue'
import LeoTrainingOperatorAssistantHost from '@/components/LeoKnowledge/LeoTrainingOperatorAssistantHost.vue'
import SocSmartGuideFloat from '@/components/LeoKnowledge/SocSmartGuideFloat.vue'

export default{
  name: 'App',
  components: { LeoAdminFloatDock, LeoNlLocalePackBanner, LeoTrainingOperatorAssistantHost, SocSmartGuideFloat },

  created(){
    initLeoFloatDockFromStorage()
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    // 版面主題以 Cookie 為準（避免舊 session 無 layoutTheme 或與 Cookie 不一致）
    this.$store.commit('SET_LAYOUT_THEME', getLayoutTheme())
  },

  mounted() {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件

    // Hash mode：必須用 fullPath（含 query）。用 path 比會把 ?sim2=1 當路徑再 push，頁面空白。
    window.addEventListener('hashchange', () => {
      let currentPath = window.location.hash.slice(1) || '/'
      if (currentPath.charAt(0) !== '/') currentPath = '/' + currentPath
      if (this.$route.fullPath !== currentPath) {
        this.$router.push(currentPath).catch(() => {})
      }
    }, false)
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })

}
}
</script>



// WEBPACK FOOTER //
// src/App.vue